import { generatePath } from 'react-router'

import { WASTE_RECORD_DETAILS } from 'portal/routes'
import { PageContainer } from 'portal/pages/PageContainer'
import { LineItemEdit } from 'portal/components/RecordsModules'
import { useModuleIds } from 'portal/lib/hooks'

export const WasteLineItemEdit = () => {
  const doneUri = useDoneRedirect()

  return (
    <PageContainer>
      <LineItemEdit doneUri={doneUri} />
    </PageContainer>
  )
}

function useDoneRedirect() {
  const { accountId, projectId, recordId, moduleName } = useModuleIds()

  return generatePath(WASTE_RECORD_DETAILS, {
    accountId,
    projectId,
    recordId,
    moduleName
  })
}
